import type { ReactNode } from 'react';
import cx from 'clsx';
import Big from 'big.js';
import { Box } from '@ff-it/ui';
import { budget as budgetClassName, budgetProgress } from './styles.css';
import { MoneyCell } from 'components/MoneyCell';

type BudgetProps = {
  budget: Big;
  amount: Big;
  details?: boolean;
};

export function Budget({ budget, amount, details }: BudgetProps): ReactNode {
  if (budget.eq(0)) {
    return null;
  }
  // const remaining = budget.minus(amount);
  const ratio = amount.div(budget).mul(100).round();

  const res = (
    <Box className={budgetClassName}>
      <progress
        value={ratio.toFixed()}
        max={100}
        className={cx(budgetProgress, ratio.gt(100) && 'overspent')}
        title={`${ratio.toFixed()}%`}
      />
      <MoneyCell
        fontSize="xs"
        fontWeight="regular"
        color="gray500"
        data-testid="budget"
        textAlign="left"
        value={budget}
      />
    </Box>
  );

  if (details) {
    return (
      <Box display="flex" alignItems="center">
        {res}
        <Box mx="2" fontWeight="regular" fontSize="xs">
          {details && `${ratio.toFixed(0)}% of budget`}
        </Box>
      </Box>
    );
  }
  return res;
}
